import { render, staticRenderFns } from "./CookiesNotice.vue?vue&type=template&id=aceee2da&scoped=true"
import script from "./CookiesNotice.vue?vue&type=script&lang=js"
export * from "./CookiesNotice.vue?vue&type=script&lang=js"
import style0 from "./CookiesNotice.vue?vue&type=style&index=0&id=aceee2da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceee2da",
  null
  
)

export default component.exports